
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { UseFormReturn } from "react-hook-form";
import type { AdminFormValues } from "@/types/admin";

interface BackgroundInformationProps {
  form: UseFormReturn<AdminFormValues>;
}

export const BackgroundInformation = ({ form }: BackgroundInformationProps) => {
  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="languages"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Vilket/vilka språk talar du?</FormLabel>
            <FormControl>
              <Input 
                {...field} 
                value={field.value.join(", ")}
                onChange={(e) => field.onChange(e.target.value.split(",").map(s => s.trim()))}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="birth_country"
        render={({ field }) => (
          <FormItem>
            <FormLabel>I vilket land är du född?</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="sweden_arrival_date"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Om du inte är född i Sverige, när flyttade du till Sverige?</FormLabel>
            <FormControl>
              <Input 
                type="date" 
                value={field.value ? field.value.toISOString().split('T')[0] : ''}
                onChange={(e) => {
                  const dateValue = e.target.value;
                  field.onChange(dateValue ? new Date(dateValue) : null);
                }}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="education_level"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Din högsta utbildning?</FormLabel>
            <FormControl>
              <RadioGroup
                onValueChange={field.onChange}
                value={field.value}
                className="flex space-x-4"
              >
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="Grundskola" id="grundskola" />
                  <label htmlFor="grundskola">Grundskola</label>
                </div>
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="Gymnasium" id="gymnasium" />
                  <label htmlFor="gymnasium">Gymnasium</label>
                </div>
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="Högskola/universitet" id="hogskola" />
                  <label htmlFor="hogskola">Högskola/universitet</label>
                </div>
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
